var map = {
	"./ENDLESS CIDER Feat. SUCH.mp3": 6837,
	"./Flowers - Miley Cyrus (Cello & Piano Cover) - Brooklyn Duo.mp3": 3695,
	"./Heuse & Tom Wilson - Ignite [NCS Release].mp3": 1374,
	"./Jake Hill - Last Laugh.mp3": 6971,
	"./Marpril - Spiral Fortune.mp3": 2172,
	"./Midranger - Apocalypse [NCS Release].mp3": 4968,
	"./MoonlightSonata-Beethoven-584836.mp3": 4718,
	"./N3WPORT - Alive (feat. Neoni) [NCS Release].mp3": 8657,
	"./NIKI - LOWKEY (ACOUSTIC).mp3": 8282,
	"./ROY KNOX - Over My Head (Feat. Mike Robert) [NCS Release].mp3": 6280,
	"./RUQOA & Pictor - Gonna Be Someone New (Piano Version).wav": 8136,
	"./RUQOA & Pictor - Gonna Be Someone New.wav": 3957,
	"./Subtact - Want You (feat. Sara Skinner) [NCS Release].mp3": 3193,
	"./Vòng Xoay.mp3": 2077,
	"./WHITE NIGHT.mp3": 2793,
	"./WokeUp-XG-14836260.mp3": 5066,
	"./lowkey.mp3": 5507,
	"./ビビデバ  星街すいせい(official).mp3": 6778,
	"./夏の記憶 (feat.初音ミク).mp3": 5306
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6032;